import { DomSanitizer } from '@angular/platform-browser';
import { FilesService } from './../../../services/shared/files/files.service';
import { Component, OnInit, Inject, Input, AfterViewInit, ChangeDetectorRef, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { makeFormDataFile } from '../../functions/file-function';
import { file_data_base } from '../../functions/shared-functions';
type AOA = any[][];

@Component({
  selector: 'app-document-view-popup',
  templateUrl: './document-view-popup.component.html',
  styleUrls: ['./document-view-popup.component.scss'],
  providers: [FilesService]

})
export class DocumentViewPopupComponent implements OnInit, AfterViewInit, OnChanges {
  dialogRef;
  data;
  constructor(
    private dialog: MatDialog,
    private file_srv: FilesService,
    private change_detector: ChangeDetectorRef,
    private injector: Injector,) {
    this.dialogRef = this.injector.get(MatDialogRef, DocumentViewPopupComponent);
    this.data = this.injector.get(MAT_DIALOG_DATA, null)
  }

  @Input() all_files;
  @Input() file;
  @Input() index;
  @Input() other_data;
  @Input() serverPathname = 'cdnPath';
  @Input() serverFilename = 'fileName';
  @Input() is_not_modal;
  loader = true;
  negative_index;
  index_outof_bound;
  reset_embed_tag = false;
  reset_object_tag = false;
  reset_all_files_flag = true;
  doc_file = false;
  file_data;
  fetching_data: boolean = false;

  storage_url = 'https://storage.googleapis.com/ezeone/icanrefer/';
  google_container_url_document = 'https://docs.google.com/viewer?url=';
  google_container_url_image = 'https://storage.googleapis.com/ezeone/icanrefer/';
  ngOnInit() {
    if (this.data && this.data.serverFilename) {
      this.serverFilename = this.data.serverFilename;
    }
    if (this.data && this.data.serverPathname) {
      this.serverPathname = this.data.serverPathname;
    }
    if (this.data && this.data.cdnpath) {
      this.getBase64(this.data.cdnpath, this.data)
    }

    if (!this.is_not_modal) {
      if (this.all_files && this.all_files.length) {
        this.all_files.forEach(file => {
          if (!file['fileName']) {
            file['fileName'] = file[this.serverFilename] || file['filename'] || '';
            file['cdnPath'] = file[this.serverPathname] || file['cdnPath'] || '';
          }
          if (!file['cdnPath']) {
            file['fileName'] = file[this.serverFilename] || file['filename'] || '';
            file['cdnPath'] = file[this.serverPathname] || file['cdnPath'] || '';
          }

        })
        console.log(this.all_files)
        this.all_files = this.previewCheck(this.all_files);
        this.reset_all_files_flag = false;
        setTimeout(() => {
          this.reset_all_files_flag = true;
        })

      }
    }


  }
  ngOnChanges(ev: SimpleChanges): void {
    if (ev.all_files) {
      console.log(ev)
      this.all_files = ev.all_files.currentValue
      if (this.all_files && this.all_files.length) {
        this.all_files.forEach(file => {
          if (!file['fileName']) {
            file['fileName'] = file[this.serverFilename] || file['filename'] || '';
            file['cdnPath'] = file[this.serverPathname] || file['cdnPath'] || '';
          }
          if (!file['cdnPath']) {
            file['fileName'] = file[this.serverFilename] || file['filename'] || '';
            file['cdnPath'] = file[this.serverPathname] || file['cdnPath'] || '';
          }

        })
        console.log(this.all_files)
        this.all_files = this.previewCheck(this.all_files);
        this.reset_all_files_flag = false;
        setTimeout(() => {
          this.reset_all_files_flag = true;
        })

      }
    }
  }

  previousFile() {
    this.doc_file = false;
    this.reset_embed_tag = false;
    this.reset_object_tag = false;
    if (this.index == 0) {
      this.index_outof_bound = false;
    }
    else {
      this.index--;
      if ((!this.all_files[this.index].file_d) && (!this.all_files[this.index].is_xlsx || !this.all_files[this.index].pptx)) {
        if (this.all_files[this.index][this.serverPathname] && this.all_files[this.index][this.serverPathname] != 'view_by_conversion') {
          this.fetching_data = true;
          this.file_srv.getDocxBase64(this.all_files[this.index][this.serverPathname], '1').subscribe(res => {


            if (res && res['data'] && res['status']) {
              this.all_files[this.index].file_data = 'data:application/pdf;base64,' + res['data']['filedata'];
            }
            else {
              this.getSignedURL(this.index)
            }
            this.fetching_data = false;
          })
        }
        else {
          this.getPdfFromFile(this.all_files[this.index]);
        }
      }
    }
    setTimeout(() => {
      this.reset_embed_tag = true;
      this.reset_object_tag = true;
    })
  }
  getSignedURL(index) {
    if (this.all_files && this.all_files.length && this.all_files[index]) {
      this.file_srv.getURL(this.all_files[index][this.serverPathname]).subscribe(res => {
        if (res) {
          if (this.all_files[this.index]) {
            this.all_files[this.index].url = res['data'].url;
          }
        }
      })
    }

  }
  nextFile() {
    this.doc_file = false;
    this.reset_embed_tag = false;
    this.reset_object_tag = false;
    if (this.index == this.all_files.length - 1) {
      this.index_outof_bound = true;
      this.index = this.all_files.length - 1;
    }
    else {
      this.index++;
      this.index_outof_bound = false;
      if ((!this.all_files[this.index].file_data) && (!this.all_files[this.index].is_xlsx || !this.all_files[this.index].pptx)) {
        if (this.all_files[this.index][this.serverPathname] && this.all_files[this.index][this.serverPathname] != 'view_by_conversion') {
          this.fetching_data = true;

          this.file_srv.getDocxBase64(this.all_files[this.index][this.serverPathname], '1').subscribe(res => {

            if (res && res['data'] && res['status']) {
              this.all_files[this.index].file_data = 'data:application/pdf;base64,' + res['data']['filedata'];
            }
            else {
              this.getSignedURL(this.index);
            }
            this.fetching_data = false;

          })
          // this.file_srv.getURL(this.all_files[this.index][this.serverPathname]).subscribe(res => {
          //   if (res && res['data']) {
          //     this.all_files[this.index].url = res['data'].url
          //   }
          // })
        }
        else {
          this.getPdfFromFile(this.all_files[this.index]);
        }
      }
    }
    this.reset_object_tag = false;
    setTimeout(() => {
      this.reset_embed_tag = true;
      this.reset_object_tag = true;
    })
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.reset_embed_tag = true;
      this.reset_object_tag = true;
    }, 200)
  }


  close() {
    console.log('closing')
    this.dialogRef.close();
    // this.dialogRef.clos
  }

  previewCheck(file_arr) {
    let file_ext = ['xlsx']
    try {
      for (let index = 0; index < file_arr.length; index++) {
        let file = file_arr[index];
        console.log(file)
        if (((file.fileName).split('.').pop()).toLowerCase() == 'docx' || ((file.fileName).split('.').pop()).toLowerCase() == 'doc') {
          file['is_doc'] = 1;
          if (this.file[this.serverPathname] && index == this.index && !file['file_data']) {
            this.fetching_data = true;

            this.file_srv.getDocxBase64(file[this.serverPathname], '1').subscribe(res => {

              if (res && res['data'] && res['status']) {
                if (this.all_files[this.index]) {
                  this.all_files[this.index].file_data = 'data:application/pdf;base64,' + res['data']['filedata'];
                }
              }
              else {
                this.getSignedURL(this.index)
              }
              this.fetching_data = false;

            })
          }
          if (file.content && file.content != '' && index == this.index) {
            file[this.serverPathname] = "view_by_conversion"
            this.getPdfFromFile(file);
            // data:image/png;base64,
          }
        }

        else if (((file.fileName).split('.').pop()).toLowerCase() == 'jpg' || ((file.fileName).split('.').pop()).toLowerCase() == 'jpeg' || ((file.fileName).split('.').pop()).toLowerCase() == 'png') {
          file['is_image'] = 1;
          if (file.content && file.content != '' && file.content.indexOf('base64') < 0) {
            if (file.contentType && file.contentType != '') {
              file.content = 'data:' + file.contentType + ';base64, ' + file.content + ''
            }
            else {
              file.content = 'data:application/pdf;base64,' + file.content + ''
            }
          }
          else {
            if (this.file[this.serverPathname] && index == this.index) {
              this.file_srv.getURL(file[this.serverPathname], '1').subscribe(res => {
                if (res) {
                  if (this.all_files[this.index]) {
                    this.all_files[this.index].url = res['data'].url;
                  }
                }
              })
            }
          }
        }

        else if (((file.fileName).split('.').pop()).toLowerCase() == 'pdf') {
          file['is_pdf'] = 1;
          if (file[this.serverPathname] && index == this.index && !file['file_data']) {
            this.fetching_data = true;

            this.file_srv.getDocxBase64(file[this.serverPathname], '1').subscribe(res => {

              if (res && res['data'] && res['status']) {
                if (this.all_files[this.index]) {
                  this.all_files[this.index].file_data = 'data:application/pdf;base64,' + res['data']['filedata'];
                }
              }
              else {
                this.getSignedURL(this.index)
              }
              this.fetching_data = false;

            })
          }
          if (file.content && file.content != '' && file.content.indexOf('base64') < 0) {
            if (file.contentType && file.contentType != '') {
              file.content = 'data:' + file.contentType + ';base64, ' + file.content
            }
            else {
              file.content = 'data:image/' + ((file.fileName).split('.').pop()).toLowerCase() + ';base64, ' + file.content
            }
          }
        }
        else if (((file.fileName).split('.').pop()).toLowerCase() == 'ppt' || ((file.fileName).split('.').pop()).toLowerCase() == 'pptx') {
          file['pptx'] = 1;
          if (file.content && file.content != '' && file.content.indexOf('base64') < 0) {
            if (file.contentType && file.contentType != '') {
              file.content = 'data:' + file.contentType + ';base64, ' + file.content
            }
            else {
              file.content = 'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64, ' + file.content
            }
          }
        }
        else if (((file.fileName).split('.').pop()).toLowerCase() == 'xlsx' || ((file.fileName).split('.').pop()).toLowerCase() == 'xlsm' || ((file.fileName).split('.').pop()).toLowerCase() == 'xls') {
          /* wire up file reader */
          file['is_xlsx'] = 1;
          let f = this.dataURLtoFile(file.content, file.fileName)
          const reader: FileReader = new FileReader();
          reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];
            /* save data */
            file['data'] = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
            console.log(JSON.stringify(file['data']));

          };
          reader.readAsBinaryString(f);

        }
        else {
          if (this.file[this.serverPathname] && index == this.index) {
            this.file_srv.getURL(file[this.serverPathname]).subscribe(res => {
              if (res) {
                if (this.all_files[this.index]) {
                  this.all_files[this.index].url = res['data'].url;
                }
              }
            })
          }

        }
        // if (this.file[this.serverPathname] && index == this.index) {
        //   this.file_srv.getURL(file[this.serverPathname]).subscribe(res => {
        //     if (res) {
        //       if (this.all_files[this.index]) {
        //         this.all_files[this.index].url = res['data'].url;
        //       }
        //     }
        //   })
        // }
      }
      return file_arr;
    } catch (error) {
      return file_arr;
    }
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  uploadFile(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      let r: any = reader.result
      return {
        // file_data: this._sanitizer.bypassSecurityTrustResourceUrl(r)
      }


    }
  }

  getBase64(cdnPath, file) {
    this.reset_object_tag = false;
    this.reset_embed_tag = false;
    this.fetching_data = true;

    this.file_srv.getDocxBase64(cdnPath).subscribe(res => {
      if (res && res['data']) {
        file.file_data = 'data:application/pdf;base64,' + res['data'].filedata;
        this.change_detector.detectChanges();
        setTimeout(() => {
          this.reset_embed_tag = true;
          this.reset_object_tag = true;
        }, 3000)
      }
      this.fetching_data = false;

    })
  }

  getPdfFromFile(file) {
    this.reset_object_tag = false;
    this.reset_embed_tag = false;
    let form_data = new FormData();
    let f = (this.file_srv.makeFormDataFile(file));
    form_data.append('attachment', f, f.name);
    this.reset_object_tag = false;
    this.reset_embed_tag = false;
    this.file_srv.docxFileToPdf(form_data).subscribe(res => {
      console.log(res)
      if (res && res['data']) {
        file['file_data'] = file_data_base + res['data'].filedata;
        this.reset_object_tag = true;
        this.reset_embed_tag = true;
      }
    })
  }

  makeFormDataFile(file) {
    return makeFormDataFile(file);
  }
  downloadFile(letter) {
    this.file_srv.saveFileFromURL(letter[this.serverPathname], letter['fileName'])
    // this.file_srv.getURL(letter[this.serverPathname]).subscribe(res=>{
    //   this.file_srv.saveFromURL(res['data'].url,letter[this.serverFilename]).subscribe(file => {
    //     if (file) {
    //       console.log(file)
    //       console.log(this.base64ToBlob(file))
    //     }
    //   })
    // })

    // let link = document.createElement("a");
    // link.download =  letter[this.serverFilename];
    // // console.log(link.download)
    // link.setAttribute('download', letter[this.serverFilename]);
    // link.href = this.storage_url + letter[this.serverPathname];
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
  }
  base64ToBlob(b64Data) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    let sliceSize = 512
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays);
    return blob;
  }
}






